var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRenotifyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2261 10.4464C14.0872 11.7514 13.3478 12.9742 12.1243 13.6806C10.0916 14.8542 7.49234 14.1577 6.31874 12.125L6.19374 11.9085M5.77259 9.55356C5.9115 8.24862 6.65089 7.02575 7.87438 6.31937C9.90713 5.14576 12.5064 5.84223 13.68 7.87498L13.805 8.09148M5.74609 13.033L6.11212 11.6669L7.47814 12.033M12.5206 7.96699L13.8866 8.33301L14.2527 6.96699M9.99938 7.74998V9.99998L11.2494 10.75",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenotifyIcon);
export default __webpack_public_path__ + "static/media/renotify-icon.e21a12dfc352dc5d153f4ca00baf30bc.svg";
export { ForwardRef as ReactComponent };